module.exports = __webpack_public_path__ + "img/Dantam Bridal 22.3c2b6bd5.jpg";